// import {
//   BsRobot,
//   BsWhatsapp,
//   BsCpu,
//   BsGear,
//   BsCheckCircleFill,
// } from "react-icons/bs";

// function AIShowcase() {
//   return (
//     <section className="ai-section">
//       <div className="container">
//         <div className="row align-items-center">
//           {/* LEFT SIDE */}

//           <div className="col-lg-6">
//             <span className="section-subtitle">AI AUTOMATION</span>

//             <h2 className="ai-title">
//               Build A Business That Works Even When You're Offline
//             </h2>

//             <p className="ai-description">
//               We help businesses automate sales, customer support, follow-ups
//               and internal operations using AI-powered systems.
//             </p>

//             <div className="ai-features">
//               <div className="ai-feature">
//                 <BsCheckCircleFill />
//                 <span>AI Chatbots</span>
//               </div>

//               <div className="ai-feature">
//                 <BsCheckCircleFill />
//                 <span>AI Agents</span>
//               </div>

//               <div className="ai-feature">
//                 <BsCheckCircleFill />
//                 <span>WhatsApp Automation</span>
//               </div>

//               <div className="ai-feature">
//                 <BsCheckCircleFill />
//                 <span>Workflow Automation</span>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT SIDE */}

//           <div className="col-lg-6 mt-5 mt-lg-0">
//             <div className="automation-board">
//               <div className="automation-center">AI SYSTEM</div>

//               <div className="automation-node top">
//                 <BsRobot />
//                 Chatbot
//               </div>

//               <div className="automation-node right">
//                 <BsWhatsapp />
//                 WhatsApp
//               </div>

//               <div className="automation-node bottom">
//                 <BsGear />
//                 Workflow
//               </div>

//               <div className="automation-node left">
//                 <BsCpu />
//                 AI Agent
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default AIShowcase;

// import {
//   BsRobot,
//   BsWhatsapp,
//   BsCpu,
//   BsGear,
//   BsCheckCircleFill,
// } from "react-icons/bs";

// function AIShowcase() {
//   return (
//     <section className="ai-section">
//       <div className="container">
//         <div className="row align-items-center">
//           {/* LEFT SIDE */}

//           <div className="col-lg-6">
//             <span className="section-subtitle">AI AUTOMATION</span>

//             <h2 className="ai-title">
//               Build A Business That Works Even When You're Offline
//             </h2>

//             <p className="ai-description">
//               Automate customer communication, lead qualification, follow-ups
//               and operational workflows using AI-powered systems built for
//               modern businesses.
//             </p>

//             <div className="ai-features">
//               <div className="ai-feature">
//                 <BsCheckCircleFill />
//                 <span>AI Chatbots</span>
//               </div>

//               <div className="ai-feature">
//                 <BsCheckCircleFill />
//                 <span>AI Agents</span>
//               </div>

//               <div className="ai-feature">
//                 <BsCheckCircleFill />
//                 <span>WhatsApp Automation</span>
//               </div>

//               <div className="ai-feature">
//                 <BsCheckCircleFill />
//                 <span>Workflow Automation</span>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT SIDE */}

//           <div className="col-lg-6 mt-5 mt-lg-0">
//             <div className="workflow-box">
//               <div className="workflow-step">
//                 <div className="workflow-icon">
//                   <BsWhatsapp />
//                 </div>

//                 <div>
//                   <h5>Lead Received</h5>
//                   <p>Customer submits enquiry</p>
//                 </div>
//               </div>

//               <div className="workflow-line"></div>

//               <div className="workflow-step">
//                 <div className="workflow-icon">
//                   <BsRobot />
//                 </div>

//                 <div>
//                   <h5>AI Response</h5>
//                   <p>Instant reply within seconds</p>
//                 </div>
//               </div>

//               <div className="workflow-line"></div>

//               <div className="workflow-step">
//                 <div className="workflow-icon">
//                   <BsCpu />
//                 </div>

//                 <div>
//                   <h5>AI Qualification</h5>
//                   <p>Filters and scores prospects</p>
//                 </div>
//               </div>

//               <div className="workflow-line"></div>

//               <div className="workflow-step">
//                 <div className="workflow-icon">
//                   <BsGear />
//                 </div>

//                 <div>
//                   <h5>Workflow Automation</h5>
//                   <p>Updates CRM and schedules actions</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default AIShowcase;

// import {
//   BsRobot,
//   BsWhatsapp,
//   BsCpu,
//   BsGear,
//   BsLightningCharge,
// } from "react-icons/bs";

// function AIShowcase() {
//   return (
//     <section className="ai-section">
//       <div className="container">
//         <div className="row align-items-center">
//           {/* LEFT */}

//           <div className="col-lg-5">
//             <span className="section-subtitle">AI AUTOMATION</span>

//             <h2 className="ai-title">
//               Build Systems That Work While You Focus On Growth
//             </h2>

//             <p className="ai-description">
//               Automate customer support, lead qualification, follow-ups and
//               business operations using AI-powered workflows.
//             </p>

//             <div className="ai-list">
//               <div>AI Chatbots</div>
//               <div>AI Agents</div>
//               <div>WhatsApp Automation</div>
//               <div>Workflow Automation</div>
//             </div>

//             <a href="#contact" className="btn-primary-custom">
//               Explore AI Solutions
//             </a>
//           </div>

//           {/* RIGHT */}

//           <div className="col-lg-7 mt-5 mt-lg-0">
//             <div className="ai-dashboard">
//               <div className="dashboard-top">
//                 <div className="status-dot"></div>
//                 AI Control Center
//               </div>

//               <div className="dashboard-grid">
//                 <div className="dashboard-widget">
//                   <BsRobot />
//                   <h5>AI Chatbot</h5>
//                   <span>24/7 Support</span>
//                 </div>

//                 <div className="dashboard-widget">
//                   <BsWhatsapp />
//                   <h5>WhatsApp</h5>
//                   <span>Lead Handling</span>
//                 </div>

//                 <div className="dashboard-widget center-widget">
//                   <BsCpu />
//                   <h4>AI Agent</h4>
//                   <p>Managing Business Operations</p>
//                 </div>

//                 <div className="dashboard-widget">
//                   <BsGear />
//                   <h5>Automation</h5>
//                   <span>Workflows</span>
//                 </div>

//                 <div className="dashboard-widget">
//                   <BsLightningCharge />
//                   <h5>Instant Actions</h5>
//                   <span>Real-Time Tasks</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default AIShowcase;

// import {
//   BsRobot,
//   BsWhatsapp,
//   BsCpu,
//   BsGear,
//   BsGraphUp,
//   BsPersonWorkspace,
// } from "react-icons/bs";

// function AIShowcase() {
//   return (
//     <section className="ai-section">
//       <div className="container">
//         <div className="row align-items-center">
//           <div className="col-lg-5">
//             <span className="section-subtitle">AI AUTOMATION</span>

//             <h2 className="ai-title">Your Business Running On Autopilot</h2>

//             <p className="ai-description">
//               Connect customer support, lead generation, follow-ups and
//               operations into one intelligent AI ecosystem.
//             </p>

//             <div className="ai-benefits">
//               <span>AI Agents</span>
//               <span>Chatbots</span>
//               <span>WhatsApp Automation</span>
//               <span>Workflow Automation</span>
//             </div>
//           </div>

//           <div className="col-lg-7">
//             <div className="orbit-wrapper">
//               <div className="orbit-center">
//                 <BsCpu />
//                 <h4>AI Core</h4>
//               </div>

//               <div className="orbit-item orbit-top">
//                 <BsRobot />
//                 <span>Chatbot</span>
//               </div>

//               <div className="orbit-item orbit-right">
//                 <BsWhatsapp />
//                 <span>WhatsApp</span>
//               </div>

//               <div className="orbit-item orbit-bottom-right">
//                 <BsGraphUp />
//                 <span>Analytics</span>
//               </div>

//               <div className="orbit-item orbit-bottom-left">
//                 <BsGear />
//                 <span>Workflow</span>
//               </div>

//               <div className="orbit-item orbit-left">
//                 <BsPersonWorkspace />
//                 <span>AI Agent</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default AIShowcase;

// import {
//   BsCpu,
//   BsRobot,
//   BsWhatsapp,
//   BsGear,
//   BsGraphUp,
//   BsPersonWorkspace,
// } from "react-icons/bs";

// function AIShowcase() {
//   return (
//     <section className="ai-section">
//       <div className="container">
//         <div className="row align-items-center">
//           {/* LEFT CONTENT */}

//           <div className="col-lg-5">
//             <span className="section-subtitle">AI AUTOMATION</span>

//             <h2 className="ai-title">
//               Intelligent Systems Built To Scale Your Business
//             </h2>

//             <p className="ai-description">
//               Deploy AI agents, chatbots, workflow automation and customer
//               communication systems that operate continuously and improve
//               efficiency across your business.
//             </p>

//             <div className="ai-tags">
//               <span>AI Agents</span>
//               <span>AI Chatbots</span>
//               <span>WhatsApp Automation</span>
//               <span>Workflow Automation</span>
//             </div>

//             <a href="#contact" className="btn-primary-custom">
//               Explore AI Solutions
//             </a>
//           </div>

//           {/* RIGHT VISUAL */}

//           <div className="col-lg-7 mt-5 mt-lg-0">
//             <div className="orbit-wrapper">
//               <div className="orbit-ring"></div>

//               <div className="connection-line line-top"></div>
//               <div className="connection-line line-right"></div>
//               <div className="connection-line line-left"></div>
//               <div className="connection-line line-bottom-left"></div>
//               <div className="connection-line line-bottom-right"></div>

//               <div className="orbit-center">
//                 <BsCpu />
//                 <h4>AI Core</h4>
//               </div>

//               <div className="orbit-item orbit-top">
//                 <BsRobot />
//                 <span>Chatbot</span>
//               </div>

//               <div className="orbit-item orbit-right">
//                 <BsWhatsapp />
//                 <span>WhatsApp</span>
//               </div>

//               <div className="orbit-item orbit-left">
//                 <BsPersonWorkspace />
//                 <span>AI Agent</span>
//               </div>

//               <div className="orbit-item orbit-bottom-left">
//                 <BsGear />
//                 <span>Workflow</span>
//               </div>

//               <div className="orbit-item orbit-bottom-right">
//                 <BsGraphUp />
//                 <span>Analytics</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default AIShowcase;

// import { BsRobot, BsWhatsapp, BsCpu, BsGear, BsBarChart } from "react-icons/bs";

// function AIShowcase() {
//   return (
//     <section className="ai-section">
//       <div className="container">
//         <div className="row align-items-center">
//           {/* LEFT */}

//           <div className="col-lg-6">
//             <span className="section-subtitle">AI AUTOMATION</span>

//             <h2 className="ai-title">
//               Intelligent Systems Built To Scale Your Business
//             </h2>

//             <p className="ai-description">
//               Deploy AI agents, chatbots, WhatsApp automation and workflow
//               systems that operate 24/7 while reducing manual work and
//               increasing efficiency.
//             </p>

//             <div className="ai-tags">
//               <span>AI Agents</span>
//               <span>Chatbots</span>
//               <span>WhatsApp Automation</span>
//               <span>Workflow Automation</span>
//             </div>

//             <a href="#contact" className="btn-primary-custom">
//               Explore AI Solutions
//             </a>
//           </div>

//           {/* RIGHT */}

//           <div className="col-lg-6 mt-5 mt-lg-0">
//             <div className="orbit-wrapper">
//               <div className="orbit-circle"></div>

//               <div className="ai-core">
//                 <BsCpu />
//                 <h4>AI Core</h4>
//               </div>

//               <div className="planet planet-1">
//                 <BsRobot />
//                 <span>Chatbot</span>
//               </div>

//               <div className="planet planet-2">
//                 <BsWhatsapp />
//                 <span>WhatsApp</span>
//               </div>

//               <div className="planet planet-3">
//                 <BsBarChart />
//                 <span>Analytics</span>
//               </div>

//               <div className="planet planet-4">
//                 <BsGear />
//                 <span>Workflow</span>
//               </div>

//               <div className="planet planet-5">
//                 <BsCpu />
//                 <span>AI Agent</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default AIShowcase;

import { BsRobot, BsWhatsapp, BsCpu, BsGear, BsBarChart } from "react-icons/bs";

function AIShowcase() {
  return (
    <section className="ai-section">
      <div className="container">
        <div className="row align-items-center">
          {/* LEFT */}

          <div className="col-lg-6">
            <span className="section-subtitle">AI AUTOMATION</span>

            <h2 className="ai-title">
              Intelligent Systems Built To Scale Your Business
            </h2>

            <p className="ai-description">
              Deploy AI agents, chatbots, WhatsApp automation and workflow
              systems that operate 24/7 while reducing manual work and improving
              customer experience.
            </p>

            <div className="ai-tags">
              <span>AI Agents</span>
              <span>AI Chatbots</span>
              <span>WhatsApp Automation</span>
              <span>Workflow Automation</span>
            </div>

            <a href="#contact" className="btn-primary-custom">
              Explore AI Solutions
            </a>
          </div>

          {/* RIGHT */}

          <div className="col-lg-6 mt-5 mt-lg-0">
            <div className="orbit-wrapper">
              <div className="orbit-ring"></div>

              <div className="orbit-system">
                <div className="planet planet-1">
                  <BsRobot />
                  <span>Chatbot</span>
                </div>

                <div className="planet planet-2">
                  <BsWhatsapp />
                  <span>WhatsApp</span>
                </div>

                <div className="planet planet-3">
                  <BsBarChart />
                  <span>Analytics</span>
                </div>

                <div className="planet planet-4">
                  <BsGear />
                  <span>Workflow</span>
                </div>

                <div className="planet planet-5">
                  <BsCpu />
                  <span>AI Agent</span>
                </div>
              </div>

              <div className="ai-core">
                <BsCpu />
                <h4>AI Core</h4>
                <p>Automation Engine</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AIShowcase;
